import { z } from 'zod'

import { listQueryZodFields } from './system'
import { ApiKeyExpirations } from '../constants/apiKeys'
import { dbEntitySchema } from './system'

export const apiKeyVenuePermissionSchema = z.object({
  id: z.string(),
  name: z.string(),
})

export const apiKeySchema = dbEntitySchema.extend({
  organization: z.string(),
  note: z.string().optional().nullable(),
  apiKey: z.string(),
  permissions: z
    .object({
      venues: z.array(apiKeyVenuePermissionSchema).optional().nullable(),
    })
    .optional(),
  expirationDate: z.date().or(z.number()).optional(),
  expirationDays: z.nativeEnum(ApiKeyExpirations),
  customExpirationDays: z.number().or(z.string()).optional(),
})

export const apiKeyListArgsSchema = z.object({
  ...listQueryZodFields,
  organization: z.string().optional(),
})
export const apiKeyCreateArgsSchema = apiKeySchema.omit({
  id: true,
  _id: true,
  deleted: true,
  modified: true,
  created: true,
  apiKey: true,
  organization: true,
})
export const apiKeyUpdateByIdArgsSchema = apiKeySchema
  .omit({
    id: true,
    _id: true,
    deleted: true,
    modified: true,
    created: true,
    apiKey: true,
    organization: true,
  })
  .partial()

//responses
export const apiKeyListResponseSchema = z.object({
  data: z.array(apiKeySchema),
})
